import { Instagram, Linkedin, Youtube, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-line pt-20 pb-10 overflow-hidden">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-2.5 h-2.5 bg-accent rotate-45" />
              <span className="font-head font-extrabold tracking-tighter text-lg">
                {BRAND.shortName}<span className="text-accent">.</span>SAC
              </span>
            </div>
            <p className="text-text-2 max-w-sm leading-relaxed">{BRAND.tagline}</p>
            <a href="/#contact" className="inline-flex items-center gap-2 mt-6 bg-accent text-ink font-head font-bold px-6 py-3 hover:bg-white transition-colors">
              Start your project <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <span className="mono-label text-text-2">Services</span>
            <ul className="mt-5 space-y-3 text-white/80">
              <li><a href="/#services" className="hover:text-accent transition-colors">Web Design</a></li>
              <li><a href="/#services" className="hover:text-accent transition-colors">Branding</a></li>
              <li><a href="/#services" className="hover:text-accent transition-colors">SEO & Marketing</a></li>
              <li><a href="/#services" className="hover:text-accent transition-colors">Social Campaigns</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="mono-label text-text-2">Contact</span>
            <ul className="mt-5 space-y-3 text-white/80">
              <li><a href={`mailto:${BRAND.email}`} className="hover:text-accent transition-colors">{BRAND.email}</a></li>
              <li><a href={`tel:${BRAND.phoneTel}`} className="hover:text-accent transition-colors">{BRAND.phone}</a></li>
              <li>{BRAND.address}</li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              {[Instagram, Linkedin, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 flex items-center justify-center border border-line hover:border-accent hover:text-accent transition-colors" aria-label="social">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="font-head font-black tracking-tighter text-[15vw] leading-none text-surface-2 select-none pointer-events-none -mb-4">
          EMERGENT
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-line">
          <p className="mono-label text-text-2 !tracking-normal !normal-case">
            © {new Date().getFullYear()} {BRAND.name}. Official Emergent Technologies Partner.
          </p>
          <a href="/admin" className="mono-label text-text-2 hover:text-accent transition-colors" data-testid="footer-admin-link">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
};
